module.exports = __webpack_public_path__ + "static/og-a8d55ba0a6400db956266f7c6e43a59a.jpg";